import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { Button } from './ui';
export const Footer = () => {
  return <>
      {/* Guarantee Section */}
      <section className="py-10 md:py-16 px-4 bg-brand-teal text-white text-center" data-id="element-71">
        <div className="max-w-3xl mx-auto" data-id="element-72">
          <ShieldCheck className="w-12 h-12 md:w-16 md:h-16 mx-auto mb-4 text-brand-cream" data-id="element-73" />
          <h2 className="font-nunito font-extrabold text-3xl md:text-4xl mb-4" data-id="element-74">
            Mi Garantía Personal de 7 Días
            <br data-id="element-75" />
            <span className="text-brand-gold" data-id="element-76">"AMALO O TE LO DEVUELVO"</span>
          </h2>
          <div className="space-y-4 text-lg text-teal-50 font-inter mt-8" data-id="element-77">
            <p data-id="element-78">
              Odio la palabra "garantía" cuando es solo una frase vacía para que
              compres. <strong data-id="element-79">Así que te hago una promesa personal.</strong>
            </p>
            <p data-id="element-80">
              Estoy absolutamente convencida de que esta guía va a cambiar la
              situación en tu casa. Pero si por cualquier razón en los próximos
              7 días sentís que no fue lo que esperabas...{' '}
              <span className="underline decoration-white/40 decoration-2 underline-offset-4 font-bold text-white" data-id="element-81">
                te devuelvo el 100% de tu dinero
              </span>
              .
            </p>
            <p className="italic" data-id="element-82">
              Sin preguntas. Sin vueltas. Sin trámites complicados.
            </p>
            <div className="bg-white/10 p-4 md:p-6 rounded-xl border border-white/20 mt-6" data-id="element-83">
              <p className="font-bold text-white text-xl" data-id="element-84">
                La única que corre el riesgo aquí soy yo.
              </p>
              <p className="mt-2" data-id="element-85">
                Vos no tenés nada que perder y potencialmente muchísimo que
                ganar.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PS Section */}
      <section className="py-10 md:py-16 px-4 bg-brand-cream" data-id="element-86">
        <div className="max-w-3xl mx-auto space-y-5 text-gray-700 font-inter text-lg" data-id="element-87">
          <div className="bg-white p-5 md:p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-88">
            <p data-id="element-89">
              <strong data-id="element-90">P.D.:</strong> Recordá que tenés mi{' '}
              <span className="underline decoration-gray-300 decoration-2 underline-offset-2" data-id="element-91">
                garantía personal de 7 días
              </span>
              . Estoy 100% segura de que vas a ver una diferencia real en tu
              casa. Pero si por alguna razón no es así,{' '}
              <em data-id="element-92">te devuelvo cada peso</em>.{' '}
              <strong data-id="element-93">El riesgo es mío. La decisión es tuya.</strong>
            </p>
          </div>
          <div className="bg-white p-5 md:p-8 rounded-2xl shadow-sm border border-brand-coral/20" data-id="element-94">
            <p data-id="element-95">
              <strong data-id="element-96">P.P.D.:</strong> Esta es una{' '}
              <strong data-id="element-97">OFERTA POR TIEMPO LIMITADO</strong>. No voy a poder
              mantener este precio y estos bonos indefinidamente. Una vez que
              cierre el lanzamiento,{' '}
              <span className="underline decoration-brand-coral/30 decoration-2 underline-offset-2" data-id="element-98">
                el precio sube y los bonos desaparecen
              </span>
              . Si estás leyendo esto ahora, tenés la oportunidad.{' '}
              <em data-id="element-99">Mañana, quizás no.</em>
            </p>
          </div>

          <div className="pt-5 text-center" data-id="element-100">
            <Button className="text-xl py-4 px-8 md:py-5 md:px-10" data-id="element-101">
              → Sí, Quiero Empezar Hoy
            </Button>
          </div>
        </div>
      </section>

      {/* Actual Footer */}
      <footer className="bg-brand-charcoal text-gray-400 py-8 px-4 text-center text-sm font-inter" data-id="element-102">
        <div className="max-w-4xl mx-auto space-y-4" data-id="element-103">
          <p data-id="element-104">
            © Cómo Ayudar a Tu Hijo con la Constipación — Todos los Derechos
            Reservados
          </p>
          <div className="flex justify-center gap-6" data-id="element-105">
            <a href="#" className="hover:text-white transition-colors" data-id="element-106">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-107">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-108">
              Soporte
            </a>
          </div>
        </div>
      </footer>
    </>;
};